export const calendarPanelStyle = {
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
  padding: 12,
};

export const calendarHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 10,
  alignItems: 'center',
  marginBottom: 10,
  flexWrap: 'wrap',
};

export const calendarToolbarStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 10,
  flexWrap: 'wrap',
};

export const calendarTitleStyle = { margin: 0, color: 'var(--text)', fontSize: 16, fontWeight: 950 };
export const calendarSubStyle = { marginTop: 3, color: 'var(--text-sub)', fontSize: 12, fontWeight: 750 };

export const legendStyle = {
  display: 'flex',
  gap: 10,
  alignItems: 'center',
  color: 'var(--text-sub)',
  fontSize: 11,
  fontWeight: 850,
};

export const legendItemStyle = { display: 'inline-flex', alignItems: 'center', gap: 5 };
export const legendDotStyle = { width: 7, height: 7, borderRadius: 99, display: 'inline-block' };

export const monthBoardStyle = {
  display: 'grid',
  gridTemplateColumns: '54px minmax(0, 1fr) 54px',
  gap: 10,
  alignItems: 'stretch',
};

export const monthBoardViewportStyle = {
  minWidth: 0,
  overflow: 'hidden',
};

export const monthListStyle = (sliding, direction, isMobile = false) => ({
  display: 'grid',
  gridTemplateColumns: isMobile ? 'minmax(0, 1fr)' : 'repeat(3, minmax(0, 1fr))',
  gap: 10,
  minWidth: 0,
  opacity: sliding ? 0.72 : 1,
  transform: sliding ? `translateX(${direction === 'next' ? '-22px' : '22px'})` : 'translateX(0)',
  transition: 'transform 260ms ease, opacity 260ms ease',
});

export function moveButtonStyle(side) {
  return {
    minWidth: 0,
    border: '1px solid var(--border)',
    borderRadius: 10,
    background: side === 'left' ? 'rgba(37,99,235,0.07)' : 'rgba(13,148,136,0.08)',
    color: 'var(--text)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    transition: 'transform 160ms ease, background 160ms ease, opacity 160ms ease',
  };
}

export const mobileMonthNavStyle = {
  display: 'grid',
  gridTemplateColumns: '42px minmax(0, 1fr) 42px',
  gap: 8,
  alignItems: 'center',
  marginBottom: 10,
};

export const mobileMonthLabelStyle = {
  minWidth: 0,
  height: 40,
  border: '1px solid var(--border)',
  borderRadius: 9,
  background: 'var(--bg)',
  color: 'var(--text)',
  fontSize: 15,
  fontWeight: 950,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export function mobileMoveButtonStyle(side) {
  return {
    width: 42,
    height: 40,
    border: '1px solid var(--border)',
    borderRadius: 9,
    background: side === 'left' ? 'rgba(37,99,235,0.07)' : 'rgba(13,148,136,0.08)',
    color: 'var(--text)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  };
}

export const monthCardStyle = {
  minWidth: 0,
  border: '1px solid var(--border)',
  borderRadius: 8,
  overflow: 'hidden',
  background: 'var(--bg)',
};

export const monthHeadStyle = {
  padding: '8px 10px',
  borderBottom: '1px solid var(--border)',
  color: 'var(--text)',
  fontSize: 13,
  background: 'rgba(37,99,235,0.07)',
};

export const weekGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
  background: 'var(--bg-muted)',
};

export const weekLabelStyle = {
  padding: '6px 0',
  textAlign: 'center',
  color: 'var(--text-sub)',
  fontSize: 11,
  fontWeight: 900,
};

export const sundayWeekLabelStyle = {
  color: '#dc2626',
};

export const saturdayWeekLabelStyle = {
  color: '#2563eb',
};

export const dateGridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
};

export const dayCellStyle = {
  minHeight: 52,
  padding: 4,
  borderRight: '1px solid var(--border)',
  borderBottom: '1px solid var(--border)',
  minWidth: 0,
  position: 'relative',
};

export const todayCellStyle = {
  boxShadow: 'inset 0 0 0 2px rgba(37,99,235,0.38)',
};

export const sundayCellStyle = {
  background: 'rgba(220,38,38,0.045)',
};

export const saturdayCellStyle = {
  background: 'rgba(37,99,235,0.045)',
};

export const holidayCellStyle = {
  background: 'rgba(220,38,38,0.08)',
};

const eventCellTone = {
  red: {
    accent: '#dc2626',
    fill: 'rgba(220,38,38,0.12)',
  },
  amber: {
    accent: '#d97706',
    fill: 'rgba(217,119,6,0.13)',
  },
  green: {
    accent: '#15803d',
    fill: 'rgba(22,163,74,0.13)',
  },
  slate: {
    accent: '#64748b',
    fill: 'rgba(100,116,139,0.12)',
  },
};

export function eventDayCellStyle(tone) {
  const color = eventCellTone[tone] || eventCellTone.green;
  return {
    outline: `2px solid ${color.accent}`,
    outlineOffset: -2,
    backgroundImage: `linear-gradient(90deg, ${color.accent} 0 5px, ${color.fill} 5px, ${color.fill} 100%)`,
  };
}

export const dateRowStyle = {
  display: 'grid',
  gap: 2,
  minWidth: 0,
  marginBottom: 4,
};

export const dayNumberStyle = {
  color: 'var(--text-muted)',
  fontSize: 10,
  fontWeight: 900,
  lineHeight: 1,
  flex: '0 0 auto',
};

export const holidayDayNumberStyle = {
  ...dayNumberStyle,
  color: '#dc2626',
};

export const sundayDayNumberStyle = {
  ...dayNumberStyle,
  color: '#dc2626',
};

export const saturdayDayNumberStyle = {
  ...dayNumberStyle,
  color: '#2563eb',
};

export const holidayNameStyle = {
  minWidth: 0,
  width: '100%',
  color: '#b91c1c',
  fontSize: 9,
  fontWeight: 900,
  lineHeight: 1.1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const eventListStyle = {
  display: 'grid',
  gap: 3,
};

export const eventButtonStyle = {
  minWidth: 0,
  height: 22,
  border: '1.5px solid',
  borderRadius: 6,
  padding: '0 5px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 4,
  fontSize: 10,
  fontWeight: 900,
  cursor: 'pointer',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
};

export const moreStyle = {
  color: 'var(--text-muted)',
  fontSize: 10,
  fontWeight: 900,
};
